import GroupedContent from 'grouped-content';
import fitvids from 'fitvids';

const rtes = new Map();

export default class Rte {
  constructor({ el }) {
    this.el = el;
    if (rtes.has(el)) return;
    rtes.set(this.el, this);
    this.setupTabs();

    fitvids({
      // pxs-video is already responsive width and fitvids adds a wrapper
      // which breaks the overlay image, among other things.
      ignore: ['.pxs-video iframe'],
    });
  }

  setupTabs() {
    this.groupedContent = new GroupedContent(this.el, { layout: 'tabs', intelliparse: false });
  }

  unload() {
    if (this.groupedContent) {
      this.groupedContent.unload();
    }

    rtes.delete(this.el);
  }
}
